export default __webpack_public_path__ + "static/media/loaderGif.952dc259.gif";